export enum EPageType {
  Gallery = 'gallery',
  VIDEO = 'video',
  FIZZ = 'fizz',
  USER = 'user',
  USER_FOLLOW = 'user_follow',
  USER_TOPIC = 'user_topic',
  POI = 'poi',
  HASHTAG = 'hashtag',
}

export const PageTypeUtils = {
  fromUrl: (url: string): EPageType | null => {
    const { pathname } = new URL(url);

    if (pathname.startsWith('/poi')) {
      return EPageType.POI;
    }
    if (pathname.startsWith('/topic')) {
      return EPageType.HASHTAG;
    }
    if (pathname.match(/^\/[^\/]+\/follow/)) {
      return EPageType.USER_FOLLOW;
    }
    if (pathname.match(/^\/[^\/]+\/topic/)) {
      return EPageType.USER_TOPIC;
    }

    // legacy article-i
    if (pathname.match(/^\/article\/i\d+/)) {
      return EPageType.Gallery;
    }

    // legacy user-share
    if (pathname.match(/^\/user\/\d+\/share/)) {
      return EPageType.USER;
    }

    const segmentCount = pathname.split('/').filter(Boolean).length;
    if (segmentCount === 1) {
      return EPageType.USER;
    }
    if (segmentCount === 2) {
      return EPageType.Gallery;
    }

    return null;
  },
};
